import clsx from "classnames";
import { HTMLAttributes } from "react";

import { RowProps } from "./Row";
import { colsSpanGenerator } from "./utils";

const colDefaultProps = {
  className: "",
  noGutters: false
};

type ColBreakpointTypes =
  | "auto"
  | { span?: number | string | "auto"; offset?: number; order?: "last" | "first" | number }
  | number
  | boolean;

export type ColProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Removes the gutter spacing between Cols as well as any added negative margins.
   */
  noGutters?: boolean;

  /**
   * The number of columns to span on extra small devices (<576px)
   * type -> (true|false) | "auto" | number | { span: (true|false) | "auto" | number, offset: number, order: "first" | "last" | number }
   */
  xs?: ColBreakpointTypes;

  /**
   * The number of columns to span on small devices (≥576px)
   * type -> (true|false) | "auto" | number | { span: (true|false) | "auto" | number, offset: number, order: "first" | "last" | number }
   */
  sm?: ColBreakpointTypes;

  /**
   * The number of columns to span on medium devices (≥768px)
   * type -> (true|false) | "auto" | number | { span: (true|false) | "auto" | number, offset: number, order: "first" | "last" | number }
   */
  md?: ColBreakpointTypes;

  /**
   * The number of columns to span on large devices (≥992px)
   * type -> (true|false) | "auto" | number | { span: (true|false) | "auto" | number, offset: number, order: "first" | "last" | number }
   */
  lg?: ColBreakpointTypes;

  /**
   * The number of columns to span on extra large devices (≥1200px)
   * type -> (true|false) | "auto" | number | { span: (true|false) | "auto" | number, offset: number, order: "first" | "last" | number }
   */
  xl?: ColBreakpointTypes;

  /**
   * Col props for Row
   */
  rowCols?: RowProps;
};

function Col(props: ColProps) {
  const { children, className, noGutters, rowCols, xs, sm, md, lg, xl, ...resProps } = props;

  const width = colsSpanGenerator({ xs, sm, md, lg, xl }, rowCols);
  const ColClass = clsx("u-relative", !noGutters && "u-col-gutters", width, className);

  return (
    <div data-testid="qa-grid-col" className={ColClass} {...resProps}>
      {children}
    </div>
  );
}

Col.defaultProps = colDefaultProps;

export default Col;
